import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import mixpanel from "mixpanel-browser/src/loader-module";
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { LoanType } from 'projects/apna-lib/src/lib/components/enums/loanStatus-enum';

@Component({
  selector: 'fa-university-suggested-vendor-list',
  templateUrl: './university-suggested-vendor-list.component.html',
  styleUrls: ['./university-suggested-vendor-list.component.scss']
})
export class UniversitySuggestedVendorListComponent implements OnInit {
  @ViewChild('openCongratulationPopup') openCongratulationPopup;
  @ViewChild('content') content;
  constructor(
    public loanService: LoanGtmService,
    private route: Router,
    private apiHelper: ApiHelperService,
    private configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public breakpointObserver: BreakpointObserver
  ) { }
  userData: {};
  isPartnerLink: boolean = false;
  isSelected: boolean[] = [];
  selectedVendors: any[] = [];
  bankId: any = this.configService.getConfig1("foreignAssist", "bankNameIdOptions");
  vendorList: any;
  partnerLogo: string;
  config: ConfigInterface = {
    showHeaderShadow: true,
    icon: "",
    showBackButton: false
  }

  loading: boolean = true;
  orientation: String;

  trackEvent(event, data = {}) {
    mixpanel.track(event, data)
  }

  ngOnInit(): void {

    this.breakpointObserver
      .observe(['(max-width: 576px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.orientation = 'vertical';
        } else {
          this.orientation = 'horizontal';
        }
      });

    const puid = this.activatedRoute.snapshot.paramMap.get('puid');

    this.spinner.show();
    let bankListId = [];
    if (this.loanService.studentDetails.universityVendors?.length > 0) {

      for (let id of this.loanService.studentDetails.universityVendors) {
        if (this.loanService.studentDetails?.countryCode !== "+91") {
          if (["mpower", "prodigy"].includes(id)) {
            bankListId.push(this.bankId[`${id}`])
          }
        }
        else if (["Secured Loan(with Property)", "Unsecured Loan(without Property)"].includes(this.loanService?.loanDetails?.loanType) as any) {
          if (!["mpower", "prodigy"].includes(id)) {
            bankListId.push(this.bankId[`${id}`])
          }
        }
      }
      this.apiHelper.getData("users", { where: { id: { inq: bankListId, type: "vendor" } }, fields: { company: true, id: true } }).then((result: any) => {
        this.vendorList = result;
        result.forEach((element: any) => {
          this.isSelected.push(false)
        });
      })
      this.loading = false;
      this.spinner.hide(); 236347
      if (puid) {
        localStorage.setItem('puid', puid);
        this.config["logout"] = `/${puid}`
        this.isPartnerLink = true;
        if (!this.loanService?.partnerDetails) {
          this.getPartnerDetails(puid);
        }
        else {
          this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
        }
        this.loading = false;
      }
      else {
        this.config["logout"] = `/`
      }
    }
    this.spinner.hide();
  }


  getPartnerDetails(partnerUid) {
    this.apiHelper.getDataById("users/partner", partnerUid).subscribe((response: any) => {
      let partnerDetails = { ...response };
      if (partnerDetails) {
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
      }
      else {
        this.isPartnerLink = false;
      }
    })
  }

  back() {
    if (this.loanService.loanDetails?.loanType == 'Secured Loan(with Property)') {
      if (this.isPartnerLink) {
        this.route.navigate(['collateral-type/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['./collateral-type']);
      return;
    }
    else if (this.loanService.loanDetails?.loanType == 'Unsecured Loan(without Property)') {
      if (this.isPartnerLink) {
        this.route.navigate(['non-collateral-type/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['./non-collateral-type']);
      return;
    }
    else {
      if (this.isPartnerLink) {
        this.route.navigate(['loan-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['./loan-details']);
      return;
    }
  }

  startOver() {
    if (this.isPartnerLink) {
      this.route.navigate(['basic-information/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['./basic-information']);
    return;
  }

  async sendApplication() {
    if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('qa') && !window.location.host.includes('uat')) {
      this.userData = {
        source: "Loan Widget",
      }
      if (this.loanService.partnerDetails) {
        this.userData["PartnerName"] = this.loanService.partnerDetails?.company.name;

      }

      this.trackEvent("Send Application on  Loan Widget  Clicked", this.userData)
    }
    let loanApplicationVendorData: any[] = [];

    if (this.selectedVendors?.length > 0) {
      for await (const single of this.selectedVendors) {
        let obj = {
          vendorId: single?.id,
          loanApplicationId: this.loanService?.loanDetails?.id,
          studentId: this.loanService?.studentDetails?.id,
        }
        loanApplicationVendorData.push(obj);
      }

      this.apiHelper.postData("loan-application-vendor/multiple", loanApplicationVendorData).subscribe((data: any) => {
        if (this.orientation === 'horizontal') {
          this.modalService.open(this.openCongratulationPopup, {
            centered: true,
            keyboard: false,
            backdrop: "static",
            size: 'l'
          })
        }
        else {
          if (this.isPartnerLink) {
            this.route.navigate(['result-page/' + this.loanService?.partnerDetails?.uid]);
          }
          else {
            this.route.navigate(['result-page'])
          }
        }
      })
      this.apiHelper.updateData("loan-applications", this.loanService.loanDetails?.id, { status: "applied" })
    }
    else {
      this.apiHelper.openSnackBar("Please select atleast one vendor");
      return;
    }
  }

  addRemoveVendor(event: any, mobile?: boolean, i?: any) {
    if (mobile) {
      this.isSelected[i] = !this.isSelected[i]
      this.updateSelectedVendors(event, this.isSelected[i])
    }
    else {
      this.updateSelectedVendors(JSON.parse(event?.target?.value), event?.target?.checked);

    }
  }

  async updateSelectedVendors(vendor: any, checked: boolean) {
    if (checked) {
      if (this.selectedVendors?.length == 0) {
        this.selectedVendors.push(vendor);
      }
      else {
        let exists = false;
        for await (const single of this.selectedVendors) {
          if (single?.id === vendor?.id) {
            exists = true;
          }
        }
        if (!exists) {
          this.selectedVendors.push(vendor);
        }
      }
    }
    else {
      this.selectedVendors = this.selectedVendors.filter((single: any) => {
        return single?.id !== vendor?.id;
      })
    }
  }

  logout() {
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

  checkStatus() {
    this.modalService.dismissAll()
    if (this.isPartnerLink) {
      this.route.navigate([`/application-status/${this.loanService?.partnerDetails?.uid}`])
      return;
    }
    this.route.navigate(['/application-status'])
  }

  prepareViewLoanAmount(amount: string) {
    return (Number((amount))).toLocaleString('en-IN', {
      maximumFractionDigits: 2,
      currency: 'INR'
    }).replace("$", "").split(".")[0].toString();
  }
  startOverMobile() {
    if (this.isPartnerLink) {
      this.route.navigate(['personal-details/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['./personal-details']);
    return;
  }
  raiseARequest() {
    this.modalService.open(this.content, { centered: true });
    let loanRequest: any = {
      id: this.loanService?.studentDetails?.id,
      name: `${this.loanService.studentDetails?.firstName + " " + this.loanService.studentDetails?.lastName}`,
      email: this.loanService.studentDetails?.email,
      mobile: this.loanService.studentDetails?.mobile,
      loanType: this.loanService.loanDetails?.loanType
    };

    if (this.isPartnerLink) {
      loanRequest.partnerName = this.loanService?.partnerDetails?.name;
      loanRequest.showAgentCode = this.loanService?.partnerDetails?.company?.showAgentCode ? true : false
    }
    this.apiHelper.postData("send-loan-application-request", loanRequest).subscribe(() => {
      this.apiHelper.openSnackBar("Sent request Successfully!");
    })
  }
}
